export const AGENT_STATUSES = {
    BUSY: 'Busy',
    AVAILABLE: 'Available',
    ON_VIDEO_CALL: 'On a Video Call',
    AFTER_CALL_WORK: 'AfterCallWork',
    OFFLINE: 'Offline',
} as const;
